/**
 * Sign Elapsed Time Counter - Displays live elapsed time since last API communication
 */

export default function initSignElapsedTime() {
	// Check if we have any sign cards with elapsed time elements
	const elapsedElements = document.querySelectorAll('.l-sign-card__elapsed');

	if (elapsedElements.length === 0) {
		return;
	}

	/**
	 * Format elapsed time in human-readable format
	 * @param {number} milliseconds - Time elapsed in milliseconds
	 * @returns {string} - Formatted time string
	 */
	function formatElapsedTime(milliseconds) {
		const totalSeconds = Math.floor(milliseconds / 1000);
		const seconds = totalSeconds % 60;
		const minutes = Math.floor(totalSeconds / 60);
		const hours = Math.floor(minutes / 60);
		const days = Math.floor(hours / 24);

		if (days > 0) {
			const remainingHours = hours % 24;
			const remainingMinutes = minutes % 60;
			return days === 1
				? `1 day ${remainingHours}h ${remainingMinutes}m ${seconds}s`
				: `${days} days ${remainingHours}h ${remainingMinutes}m ${seconds}s`;
		} else if (hours > 0) {
			const remainingMinutes = minutes % 60;
			return `${hours}h ${remainingMinutes}m ${seconds}s`;
		} else if (minutes > 0) {
			return `${minutes}m ${seconds}s`;
		} else {
			return `${totalSeconds}s`;
		}
	}

	/**
	 * Update all elapsed time counters on the page
	 */
	function updateElapsedTimers() {
		const now = Date.now();

		elapsedElements.forEach(element => {
			const timestamp = element.getAttribute('data-timestamp');
			if (timestamp) {
				try {
					const lastCommunication = new Date(timestamp).getTime();
					const elapsed = now - lastCommunication;
					const valueElement = element.querySelector('.l-sign-card__elapsed-value');

					if (valueElement) {
						valueElement.textContent = formatElapsedTime(elapsed);
					}
				} catch (error) {
					console.error('Error parsing timestamp:', timestamp, error);
				}
			}
		});
	}

	// Initial update
	updateElapsedTimers();

	// Update every second
	const intervalId = setInterval(updateElapsedTimers, 1000);

	// Clean up on page unload
	window.addEventListener('beforeunload', () => {
		clearInterval(intervalId);
	});

	// Return public API
	return {
		updateElapsedTimers,
		formatElapsedTime
	};
}
